import axios, { AxiosInstance } from "axios";
import { SelectionProvider } from "../../types/selection/selection";
import { getVariableByEnv } from "../../utils/variableByEnv";
import BaseUploadProvider, { UploadItem } from "./BaseUploadProvider";

const FOTOM_URL = getVariableByEnv("REACT_APP_FOTOM_SELECTION_URL");

export default class FotomUploadProvider extends BaseUploadProvider {
  api: AxiosInstance;

  constructor(cheerzHost: string, cheerzUserId: string, cheerzUserToken: string) {
    super();

    const headers: { [key: string]: string } = {
      Accept: "application/json",
      "CZ-HOST": cheerzHost,
      "CZ-ID": cheerzUserId,
      "Fotom-Token": cheerzUserToken,
    };

    const baseURL = `${FOTOM_URL}/api/v2/`;

    this.api = axios.create({
      baseURL,
      headers,
    });
  }

  async doUpload(uploadItem: UploadItem): Promise<void> {
    const requestData = new FormData();
    requestData.append("provider_tag", uploadItem.selectionPhoto.provider);

    let endpoint;
    if (uploadItem.file) {
      endpoint = "/uploads";
      requestData.append("file", uploadItem.file);
    } else if (uploadItem.selectionPhoto.providerPictureUrl) {
      endpoint = "/remote_uploads";
      requestData.append("provider_fk", uploadItem.selectionPhoto.providerRef);
      requestData.append("photo_url", uploadItem.selectionPhoto.providerPictureUrl);
    } else {
      throw new Error("Don't know what to upload to Fotom");
    }

    const { data } = await this.api.post<FotomUploadResponse>(endpoint, requestData);
    const { height_px: heightPx, sha1, width_px: widthPx } = data.response;

    uploadItem.selectionPhoto.fotomKey = sha1;

    if (uploadItem.file) {
      uploadItem.selectionPhoto.providerRef = sha1;
      uploadItem.selectionPhoto.width.value = widthPx;
      uploadItem.selectionPhoto.height.value = heightPx;
    }
  }
}

// https://fotom.cheerz.com/api/v2/uploads

interface FotomUploadResponse {
  response: {
    height_px: number;
    provider_tag: SelectionProvider;
    sha1: string;
    taken_at?: string;
    width_px: number;
  };
}
